(() => {
  const UF = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapa',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceara',
    DF: 'Distrito Federal',
    ES: 'Espirito Santo',
    GO: 'Goias',
    MA: 'Maranhao',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Para',
    PB: 'Paraiba',
    PR: 'Parana',
    PE: 'Pernambuco',
    PI: 'Piaui',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondonia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'Sao Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  };

  const formatCep = (value) => {
    const digits = String(value).replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  };

  const formatMoney = (amount, format) => {
    const cents = Math.round(Number(amount) * 100);
    const value = (cents / 100).toFixed(2).replace('.', ',');
    const withThousands = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (!format) return `R$ ${withThousands}`;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withThousands)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withThousands.split(',')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withThousands);
  };

  const jsonFetch = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(data.description || data.message || 'request_failed');
      error.status = response.status;
      throw error;
    }
    return data;
  };

  const getRates = async ({ zip, country, province, city }) => {
    const params = new URLSearchParams({
      'shipping_address[zip]': zip,
      'shipping_address[country]': country,
      'shipping_address[province]': province,
      'shipping_address[city]': city || '',
    });
    return jsonFetch(`/cart/shipping_rates.json?${params.toString()}`);
  };

  const withVariantInCart = async (variantId, run) => {
    const cart = await jsonFetch('/cart.js');
    const existing = cart.items.find((item) => String(item.variant_id) === String(variantId));
    if (!existing) {
      await jsonFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
    }
    try {
      return await run();
    } finally {
      if (!existing) {
        await jsonFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 0 }),
        });
      }
    }
  };

  const bind = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    const form = root.querySelector('[data-bp-shipping-form]');
    const input = root.querySelector('input[name="cep"]');
    const result = root.querySelector('[data-bp-shipping-result]');
    const button = root.querySelector('.bp-ship__btn');
    if (!form || !input || !result) return;

    const show = (html, isError = false) => {
      result.hidden = false;
      result.classList.toggle('is-error', isError);
      result.innerHTML = html;
    };

    input.addEventListener('input', () => {
      input.value = formatCep(input.value);
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.name !== 'id') return;
      if (!target.closest('product-form-component, .product-details')) return;
      root.dataset.variantId = target.value;
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        show('Digite um CEP válido com 8 dígitos.', true);
        return;
      }

      const variantId = root.dataset.variantId;
      if (!variantId) {
        show('Selecione uma opção do produto para calcular o frete.', true);
        return;
      }

      button.disabled = true;
      show('Consultando o CEP e as opções de entrega...');

      try {
        const address = await fetch(`https://viacep.com.br/ws/${cep}/json/`).then((res) => res.json());
        if (!address || address.erro) {
          show('CEP não encontrado. Confira os números e tente de novo.', true);
          return;
        }

        const province = UF[address.uf] || address.uf;
        const zip = formatCep(cep);
        const city = address.localidade || '';

        const data = await withVariantInCart(variantId, async () => {
          try {
            return await getRates({ zip, country: 'BR', province, city });
          } catch (error) {
            return getRates({ zip, country: 'Brazil', province, city });
          }
        });

        const rates = data.shipping_rates || [];
        if (!rates.length) {
          show(
            `Não há frete cadastrado para ${city}/${address.uf}. Confira as zonas de entrega no admin da Shopify.`,
            true
          );
          return;
        }

        const format = root.dataset.moneyFormat;
        const items = rates
          .map((rate) => {
            const days = Array.isArray(rate.delivery_days) && rate.delivery_days.length
              ? ` · ${rate.delivery_days.filter(Boolean).join(' a ')} dias`
              : '';
            return `<li><span>${rate.presentment_name || rate.name}</span><strong>${formatMoney(
              rate.price,
              format
            )}</strong>${days ? `<small>${days}</small>` : ''}</li>`;
          })
          .join('');

        show(
          `<p class="bp-ship__city">${city} — ${address.uf}</p><ul class="bp-ship__rates">${items}</ul>`
        );
      } catch (error) {
        show('Não foi possível calcular agora. Tente de novo em instantes.', true);
      } finally {
        button.disabled = false;
      }
    });
  };

  const init = () => document.querySelectorAll('[data-bp-shipping]').forEach(bind);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
